module.exports = __webpack_public_path__ + "static/media/hw.913380cf.png";